export const BookUploadsEnabled : boolean = true;

// export const BookUploadsDisabledMessage : string = "Due to overwhelming interest from storytellers like you, we're carefully scaling our manuscript processing system. Your spot in line is secured, and we're working to get you creating as soon as possible.";

export const BookUploadsDisabledMessage : string = "Story Stream is currently in beta and we're working hard to get it ready for you! We will be releasing our full product line up in June 2025!";

/**
 * Contact Us Page Url
 */
export const ContactUsPageURL : string = "/docs/general/contact";
